<template>
  <section class="section__primary">
    <h1 class="section__title">Informations complémentaires</h1>
    <div class="section__body">
      <div class="mb-6 flex w-full">
        <ag-grid-wrapper
          editable="true"
          no_filters="true"
          description="Indiquez vos autres interventions (rédaction d'ouvrages, d'articles…)"
          v-bind:column_defs="[
            {
              headerName: 'Année',
              field: 'annee',
              type: 'annees62',
              cellRenderer: 'textCellRendererEditable',
              width: 100
            },
            {
              headerName: 'Objet',
              field: 'objet',
              type: 'textWithMax',
              cellEditorParams: { maxLength: 150 },
              cellRenderer: 'textCellRendererEditable',
              flex: 1,
              minWidth: 200
            }
          ]"
          v-bind:initial_data="cv_form.interventions"
          v-on:cell-value-changed="set_attribute($event, 'interventions')" />
      </div>
    </div>
  </section>
</template>
<script>
  import agGridWrapper from '@/components/utils/ag-grid/ag-grid-wrapper';

  export default {
    components: { agGridWrapper },
    props: ['cv_form', 'set_attribute']
  };
</script>
<style lang="scss" scoped></style>
